import { useEffect } from 'react';
import Modal from 'react-modal';
import { customStyles } from 'utils/modalSettings';
import useModal from 'utils/useModal';
import Onboarding from './Onboarding';

const customStylesOverride = {
  ...customStyles,
  content: {
    ...customStyles.content,
    filter: 'drop-shadow(0px 32px 64px rgba(17, 17, 17, 0.08))',
    borderRadius: '24px',
    overflowX: 'hidden',
  }
};

const ModalOnboarding = () => {
  const [isOpen, closeModal, openModal] = useModal('onboarding');

  useEffect(() => {
    const isOnboardingComplete = localStorage.getItem('isOnboardingComplete');

    if (!isOnboardingComplete) {
      openModal();
    }
  }, [openModal]);

  return (
    <Modal
      style={customStylesOverride}
      isOpen={isOpen}
      onRequestClose={() => closeModal(false)}
    >
      <Onboarding />
    </Modal>
  );
}

export default ModalOnboarding;